import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-15a528a1")
const _hoisted_1 = {
  key: 0,
  class: "single-offer-details",
  ref: "offerDetails"
}
const _hoisted_2 = { class: "row mb-4" }
const _hoisted_3 = { class: "col-12 d-md-flex align-items-center" }
const _hoisted_4 = { class: "single-offer-details__logo" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "helper" }, null, -1)
const _hoisted_6 = { class: "title title--xsmall ms-md-4 mb-0" }
const _hoisted_7 = { class: "row single-offer-fs-18" }
const _hoisted_8 = { class: "col-6 col-md-3 mb-4" }
const _hoisted_9 = { class: "col-6 col-md-3 mb-4" }
const _hoisted_10 = { class: "col-6 col-md-3 mb-4" }
const _hoisted_11 = { class: "col-6 col-md-3 mb-4" }
const _hoisted_12 = { class: "title title--xsmall title--with-btn lh-initial color-primary mt-5 mb-4 mx-0" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "title title--xsmall title--with-btn lh-initial color-primary mt-5 mb-4 mx-0" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "title title--xsmall title--with-btn lh-initial color-primary mt-5 mb-4 mx-0" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" -")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" -")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" -")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" -")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_notus_logo_bank = _resolveComponent("notus-logo-bank")!
  const _component_notus_form_static = _resolveComponent("notus-form-static")!
  const _component_notus_offer_details_accordion = _resolveComponent("notus-offer-details-accordion")!
  const _component_notus_svg_icon = _resolveComponent("notus-svg-icon")!

  return (_ctx.transformedOffer?.detailed_information)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_notus_logo_bank, {
                "bank-name": _ctx.transformedOffer.detailed_information.logo,
                "center-vertical": true,
                size: "xl"
              }, null, 8, ["bank-name"])
            ]),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.transformedOffer.detailed_information.text), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_notus_form_static, {
              label: _ctx.$t('page.comparition.table.parameters.monthly_instalment'),
              value: 
            _ctx.roundedAmountFilter(_ctx.offer.simulationSummary.finalInstallment.CAPITAL_AND_INTEREST.value) +
            ' ' +
            _ctx.offer.simulationSummary.finalInstallment.CAPITAL_AND_INTEREST.currency
          
            }, null, 8, ["label", "value"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_notus_form_static, {
              label: _ctx.$t('page.comparition.table.parameters.total_amount_to_paid'),
              value: 
            _ctx.roundedAmountFilter(_ctx.transformedOffer.total_amount_to_paid.value) +
            ' ' +
            _ctx.transformedOffer.total_amount_to_paid.currency
          
            }, null, 8, ["label", "value"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_notus_form_static, {
              label: _ctx.$t('page.comparition.table.parameters.interest_rate'),
              value: _ctx.transformedOffer.interest_rate
            }, null, 8, ["label", "value"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_notus_form_static, {
              label: _ctx.$t('page.comparition.table.parameters.RRSO'),
              value: _ctx.transformedOffer.RRSO
            }, null, 8, ["label", "value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('page.comparition.table.parameters.detailed_information')), 1),
          _createElementVNode("div", {
            class: "show-details__btn color-accent fw-bold fs-18",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchAll(_ctx.detailsType.DETAILS)))
          }, [
            (_ctx.isAllDetailsOpened)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.collapse_all')), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.expand_all')), 1)
                ], 64))
          ])
        ]),
        _createVNode(_component_notus_offer_details_accordion, {
          active: _ctx.collapseStates[_ctx.detailsType.DETAILS][0],
          "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => (_ctx.collapseStates[_ctx.detailsType.DETAILS][0] = $event))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.parameters.LTV')), 1)
          ]),
          content: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.tooltips.LTV')), 1)
          ]),
          value: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.transformedOffer.LTV), 1)
          ]),
          _: 1
        }, 8, ["active"]),
        _createVNode(_component_notus_offer_details_accordion, {
          active: _ctx.collapseStates[_ctx.detailsType.DETAILS][1],
          "onUpdate:active": _cache[2] || (_cache[2] = ($event: any) => (_ctx.collapseStates[_ctx.detailsType.DETAILS][1] = $event))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.parameters.loan_period')), 1)
          ]),
          content: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.tooltips.loan_period')), 1)
          ]),
          value: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.transformedOffer.loan_period) + " " + _toDisplayString(_ctx.$tc('general.suffix.year', _ctx.transformedOffer.loan_period)), 1)
          ]),
          _: 1
        }, 8, ["active"]),
        _createVNode(_component_notus_offer_details_accordion, {
          active: _ctx.collapseStates[_ctx.detailsType.DETAILS][2],
          "onUpdate:active": _cache[3] || (_cache[3] = ($event: any) => (_ctx.collapseStates[_ctx.detailsType.DETAILS][2] = $event))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.parameters.instalment_type')), 1)
          ]),
          content: _withCtx(() => [
            _createElementVNode("div", {
              innerHTML: _ctx.$t('page.comparition.table.tooltips.instalment_type')
            }, null, 8, _hoisted_13)
          ]),
          value: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t(`page.comparition.table.instalment_type_${_ctx.transformedOffer.instalment_type}`)), 1)
          ]),
          _: 1
        }, 8, ["active"]),
        _createVNode(_component_notus_offer_details_accordion, {
          active: _ctx.collapseStates[_ctx.detailsType.DETAILS][3],
          "onUpdate:active": _cache[4] || (_cache[4] = ($event: any) => (_ctx.collapseStates[_ctx.detailsType.DETAILS][3] = $event))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.parameters.interest_rate')), 1)
          ]),
          content: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.tooltips.interest_rate')), 1)
          ]),
          value: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.transformedOffer.interest_rate), 1)
          ]),
          _: 1
        }, 8, ["active"]),
        _createVNode(_component_notus_offer_details_accordion, {
          active: _ctx.collapseStates[_ctx.detailsType.DETAILS][4],
          "onUpdate:active": _cache[5] || (_cache[5] = ($event: any) => (_ctx.collapseStates[_ctx.detailsType.DETAILS][4] = $event))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.parameters.margin')), 1)
          ]),
          content: _withCtx(() => [
            _createElementVNode("div", {
              innerHTML: _ctx.$t('page.comparition.table.tooltips.margin')
            }, null, 8, _hoisted_14)
          ]),
          value: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.transformedOffer.margin), 1)
          ]),
          _: 1
        }, 8, ["active"]),
        _createVNode(_component_notus_offer_details_accordion, {
          active: _ctx.collapseStates[_ctx.detailsType.DETAILS][5],
          "onUpdate:active": _cache[6] || (_cache[6] = ($event: any) => (_ctx.collapseStates[_ctx.detailsType.DETAILS][5] = $event))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.parameters.commission')), 1)
          ]),
          content: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.tooltips.commission')), 1)
          ]),
          value: _withCtx(() => [
            _createTextVNode(_toDisplayString(!_ctx.emptyOrNull(_ctx.transformedOffer.commission.percent) ? _ctx.transformedOffer.commission.percent : _ctx.percentFilter(0)), 1)
          ]),
          additional: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.amountFilter(_ctx.transformedOffer.commission.value) + ' ' + _ctx.transformedOffer.commission.currency), 1)
          ]),
          _: 1
        }, 8, ["active"]),
        _createVNode(_component_notus_offer_details_accordion, {
          active: _ctx.collapseStates[_ctx.detailsType.DETAILS][6],
          "onUpdate:active": _cache[7] || (_cache[7] = ($event: any) => (_ctx.collapseStates[_ctx.detailsType.DETAILS][6] = $event))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.parameters.valuation')), 1)
          ]),
          content: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.tooltips.valuation')), 1)
          ]),
          value: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.amountFilter(_ctx.transformedOffer.valuation.value)) + " " + _toDisplayString(_ctx.transformedOffer.valuation.currency), 1)
          ]),
          additional: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.valuations.' + _ctx.transformedOffer.valuation.text)), 1)
          ]),
          _: 1
        }, 8, ["active"]),
        _createVNode(_component_notus_offer_details_accordion, {
          active: _ctx.collapseStates[_ctx.detailsType.DETAILS][7],
          "onUpdate:active": _cache[8] || (_cache[8] = ($event: any) => (_ctx.collapseStates[_ctx.detailsType.DETAILS][7] = $event))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.parameters.initial_costs')), 1)
          ]),
          content: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.tooltips.initial_costs')), 1)
          ]),
          value: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.roundedAmountFilter(_ctx.transformedOffer.initial_costs.value)) + " " + _toDisplayString(_ctx.transformedOffer.initial_costs.currency), 1)
          ]),
          _: 1
        }, 8, ["active"]),
        _createVNode(_component_notus_offer_details_accordion, {
          active: _ctx.collapseStates[_ctx.detailsType.DETAILS][8],
          "onUpdate:active": _cache[9] || (_cache[9] = ($event: any) => (_ctx.collapseStates[_ctx.detailsType.DETAILS][8] = $event))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.parameters.total_amount_to_paid')), 1)
          ]),
          content: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.tooltips.total_amount_to_paid')), 1)
          ]),
          value: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.roundedAmountFilter(_ctx.transformedOffer.total_amount_to_paid.value)) + " " + _toDisplayString(_ctx.transformedOffer.total_amount_to_paid.currency), 1)
          ]),
          _: 1
        }, 8, ["active"]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('page.comparition.table.parameters.insurance')), 1),
          _createElementVNode("div", {
            class: "show-details__btn color-accent fw-bold fs-18",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.switchAll(_ctx.detailsType.INSURANCE_PACKAGE)))
          }, [
            (_ctx.isAllInsurancesOpened)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.collapse_all')), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.expand_all')), 1)
                ], 64))
          ])
        ]),
        _createVNode(_component_notus_offer_details_accordion, {
          active: _ctx.collapseStates[_ctx.detailsType.INSURANCE_PACKAGE][0],
          "onUpdate:active": _cache[11] || (_cache[11] = ($event: any) => (_ctx.collapseStates[_ctx.detailsType.INSURANCE_PACKAGE][0] = $event))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.parameters.mortage_insurance')), 1)
          ]),
          content: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.tooltips.mortage_insurance')), 1)
          ]),
          value: _withCtx(() => [
            _createTextVNode(_toDisplayString(!_ctx.emptyOrNull(_ctx.transformedOffer.mortage_insurance.value)
            ? _ctx.roundedAmountFilter(_ctx.transformedOffer.mortage_insurance.value) + ' ' + _ctx.transformedOffer.mortage_insurance.currency
            : '-'), 1)
          ]),
          additional: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.insurancePeriod(_ctx.transformedOffer.mortage_insurance)), 1)
          ]),
          _: 1
        }, 8, ["active"]),
        _createVNode(_component_notus_offer_details_accordion, {
          active: _ctx.collapseStates[_ctx.detailsType.INSURANCE_PACKAGE][1],
          "onUpdate:active": _cache[12] || (_cache[12] = ($event: any) => (_ctx.collapseStates[_ctx.detailsType.INSURANCE_PACKAGE][1] = $event))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.parameters.insurance_missing_contribution')), 1)
          ]),
          content: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.tooltips.insurance_missing_contribution')), 1)
          ]),
          value: _withCtx(() => [
            _createTextVNode(_toDisplayString(!_ctx.emptyOrNull(_ctx.transformedOffer.insurance_missing_contribution.value)
            ? _ctx.roundedAmountFilter(_ctx.transformedOffer.insurance_missing_contribution.value) +
              ', ' +
              _ctx.transformedOffer.insurance_missing_contribution.currency
            : '-'), 1)
          ]),
          additional: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.insurancePeriod(_ctx.transformedOffer.insurance_missing_contribution)), 1)
          ]),
          _: 1
        }, 8, ["active"]),
        _createVNode(_component_notus_offer_details_accordion, {
          active: _ctx.collapseStates[_ctx.detailsType.INSURANCE_PACKAGE][2],
          "onUpdate:active": _cache[13] || (_cache[13] = ($event: any) => (_ctx.collapseStates[_ctx.detailsType.INSURANCE_PACKAGE][2] = $event))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.parameters.real_estate_insurance')), 1)
          ]),
          content: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.tooltips.real_estate_insurance')), 1)
          ]),
          value: _withCtx(() => [
            _createTextVNode(_toDisplayString(!_ctx.emptyOrNull(_ctx.transformedOffer.real_estate_insurance.value)
            ? _ctx.roundedAmountFilter(_ctx.transformedOffer.real_estate_insurance.value) +
              ' ' +
              _ctx.transformedOffer.real_estate_insurance.currency
            : _ctx.$t('page.comparition.table.lackOf.real_estate_insurance')), 1)
          ]),
          additional: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.insurancePeriod(_ctx.transformedOffer.real_estate_insurance)), 1)
          ]),
          _: 1
        }, 8, ["active"]),
        _createVNode(_component_notus_offer_details_accordion, {
          active: _ctx.collapseStates[_ctx.detailsType.INSURANCE_PACKAGE][3],
          "onUpdate:active": _cache[14] || (_cache[14] = ($event: any) => (_ctx.collapseStates[_ctx.detailsType.INSURANCE_PACKAGE][3] = $event))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.parameters.life_insurance')), 1)
          ]),
          content: _withCtx(() => [
            _createElementVNode("div", {
              innerHTML: _ctx.$t('page.comparition.table.tooltips.life_insurance')
            }, null, 8, _hoisted_16)
          ]),
          value: _withCtx(() => [
            _createTextVNode(_toDisplayString(!_ctx.emptyOrNull(_ctx.transformedOffer.life_insurance.value)
            ? _ctx.roundedAmountFilter(_ctx.transformedOffer.life_insurance.value) + ' ' + _ctx.transformedOffer.life_insurance.currency
            : '-'), 1)
          ]),
          additional: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.insurancePeriod(_ctx.transformedOffer.life_insurance)), 1)
          ]),
          _: 1
        }, 8, ["active"]),
        _createVNode(_component_notus_offer_details_accordion, {
          active: _ctx.collapseStates[_ctx.detailsType.INSURANCE_PACKAGE][4],
          "onUpdate:active": _cache[15] || (_cache[15] = ($event: any) => (_ctx.collapseStates[_ctx.detailsType.INSURANCE_PACKAGE][4] = $event))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.parameters.employment_insurance')), 1)
          ]),
          content: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.tooltips.employment_insurance')), 1)
          ]),
          value: _withCtx(() => [
            _createTextVNode(_toDisplayString(!_ctx.emptyOrNull(_ctx.transformedOffer.employment_insurance.value)
            ? _ctx.roundedAmountFilter(_ctx.transformedOffer.employment_insurance.value) +
              ' ' +
              _ctx.transformedOffer.employment_insurance.currency
            : '-'), 1)
          ]),
          additional: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.insurancePeriod(_ctx.transformedOffer.employment_insurance)), 1)
          ]),
          _: 1
        }, 8, ["active"]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('page.comparition.table.parameters.additional_products')), 1),
          _createElementVNode("div", {
            class: "show-details__btn color-accent fw-bold fs-18",
            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.switchAll(_ctx.detailsType.ADDITIONAL)))
          }, [
            (_ctx.isAllAdditionalOpened)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.collapse_all')), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.expand_all')), 1)
                ], 64))
          ])
        ]),
        _createVNode(_component_notus_offer_details_accordion, {
          active: _ctx.collapseStates[_ctx.detailsType.ADDITIONAL][0],
          "onUpdate:active": _cache[17] || (_cache[17] = ($event: any) => (_ctx.collapseStates[_ctx.detailsType.ADDITIONAL][0] = $event))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.parameters.ROR')), 1)
          ]),
          content: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.tooltips.ROR')), 1)
          ]),
          value: _withCtx(() => [
            (_ctx.transformedOffer.ROR)
              ? (_openBlock(), _createBlock(_component_notus_svg_icon, {
                  key: 0,
                  "icon-type": "checked-comparison"
                }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_18
                ], 64))
          ]),
          _: 1
        }, 8, ["active"]),
        _createVNode(_component_notus_offer_details_accordion, {
          active: _ctx.collapseStates[_ctx.detailsType.ADDITIONAL][1],
          "onUpdate:active": _cache[18] || (_cache[18] = ($event: any) => (_ctx.collapseStates[_ctx.detailsType.ADDITIONAL][1] = $event))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.parameters.ROR_income_protection')), 1)
          ]),
          content: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.tooltips.ROR_income_protection')), 1)
          ]),
          value: _withCtx(() => [
            (_ctx.transformedOffer.ROR_income_protection)
              ? (_openBlock(), _createBlock(_component_notus_svg_icon, {
                  key: 0,
                  "icon-type": "checked-comparison"
                }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_19
                ], 64))
          ]),
          _: 1
        }, 8, ["active"]),
        _createVNode(_component_notus_offer_details_accordion, {
          active: _ctx.collapseStates[_ctx.detailsType.ADDITIONAL][2],
          "onUpdate:active": _cache[19] || (_cache[19] = ($event: any) => (_ctx.collapseStates[_ctx.detailsType.ADDITIONAL][2] = $event))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.parameters.credit_card')), 1)
          ]),
          content: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.tooltips.credit_card')), 1)
          ]),
          value: _withCtx(() => [
            (_ctx.transformedOffer.credit_card)
              ? (_openBlock(), _createBlock(_component_notus_svg_icon, {
                  key: 0,
                  "icon-type": "checked-comparison"
                }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_20
                ], 64))
          ]),
          _: 1
        }, 8, ["active"]),
        _createVNode(_component_notus_offer_details_accordion, {
          active: _ctx.collapseStates[_ctx.detailsType.ADDITIONAL][3],
          "onUpdate:active": _cache[20] || (_cache[20] = ($event: any) => (_ctx.collapseStates[_ctx.detailsType.ADDITIONAL][3] = $event))
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.parameters.debit_card')), 1)
          ]),
          content: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('page.comparition.table.tooltips.debit_card')), 1)
          ]),
          value: _withCtx(() => [
            (_ctx.transformedOffer.debit_card)
              ? (_openBlock(), _createBlock(_component_notus_svg_icon, {
                  key: 0,
                  "icon-type": "checked-comparison"
                }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_21
                ], 64))
          ]),
          _: 1
        }, 8, ["active"])
      ], 512))
    : _createCommentVNode("", true)
}